/**
 * Show a Bootstrap modal.
 * Returns Promise which resolves when the modal is shown.
 */
exports._showModal = function(elem) {
  const modal = elem.data('bs.modal');
  if(modal && modal.isShown) {
    console.log('Modal already shown, ignoring showModal()');
    return Promise.resolve();
  }

  const finished = new Promise(resolve => elem.one('shown.bs.modal', () => resolve()));
  if(window.__addTask__) {
    const task = 'showModal:' + elem.attr('id');
    window.__addTask__(task);
    finished.then(() => window.__doneTask__(task));
  }
  elem.modal('show');
  return finished;
}

/**
 * Show a Bootstrap modal.
 * Returns Promise which resolves when the modal is hidden.
 */
exports._hideModal = function(elem) {
  const modal = elem.data('bs.modal');
  if(!modal || !modal.isShown) {
    console.log('Modal already hidden, ignoring hideModal()');
    return Promise.resolve();
  }

  const finished = new Promise(resolve => elem.one('hidden.bs.modal', () => resolve()));
  if(window.__addTask__) {
    const task = 'hideModal:' + elem.attr('id');
    window.__addTask__(task);
    finished.then(() => window.__doneTask__(task));
  }
  elem.modal('hide');
  return finished;
}

exports.wrapNode = function(node) {
  return jQuery(node);
}
